import { ModalConfirmation, ModalConfirmationProps, Text, useModal } from '@billy/design-system'
import round from 'lodash/round'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { exchangeRateWarningTranslationKeys } from '@features/paymentReconciliationModal/elements/ExchangeRateDeviationWarning/utils'
import { calculateConvertedAmount } from '@features/paymentReconciliationModal/utils'

import type { CurrencyMismatchData } from '../MatchButton/utils/getCurrencyMismatchData'

interface CurrencyMismatchModalProps extends ModalConfirmationProps {
  data: CurrencyMismatchData
  onConfirm: () => void
}

export const CurrencyMismatchModal = ({ id, data, onConfirm, ...props }: CurrencyMismatchModalProps): ReactElement => {
  const { t } = useTranslation()
  const { close } = useModal(id)
  const { bankLineAmount, currencyId, deviation, exchangeRate, subjectAmount } = data

  const handleOkClick = useCallback(() => {
    close()
    onConfirm()
  }, [close, onConfirm])

  const isHigher = bankLineAmount > calculateConvertedAmount(exchangeRate, subjectAmount)
  const i18nKey = isHigher
    ? exchangeRateWarningTranslationKeys.bankLines.higher
    : exchangeRateWarningTranslationKeys.bankLines.lower

  return (
    <ModalConfirmation
      {...props}
      id={id}
      cancelLabel={t('cancel')}
      message={
        <Text colorVariant="secondary">{t(i18nKey, { currencyId, deviation: round(deviation), subjectAmount })}</Text>
      }
      okLabel={t('bank_transactions.drawer.currency_mismatch_modal.ok')}
      onOk={handleOkClick}
      title={t('bank_transactions.drawer.currency_mismatch_modal.title')}
    />
  )
}
